import BaseResource from './BaseResource';
import QuoteAttachmentResource from './QuoteAttachmentResource';
import QuoteConversationResource from './QuoteConversationResource';
import QuotePurchaseEmailResource from './QuotePurchaseEmailResource';
import QuotePurchaseSettingsResource from './QuotePurchaseSettingsResource';
import QuoteItemResource from './QuoteItemResource';

export default class QuoteResource extends BaseResource {
  constructor(url) {
    super({ url });
  }

  get() {
    return super
      .get()
      .then((response) => response)
      .catch((error) => error.response);
  }

  update(data) {
    return super
      .patch(data)
      .then((response) => response)
      .catch((error) => error.response);
  }

  delete() {
    return super
      .delete()
      .then((response) => response)
      .catch((error) => error.response);
  }

  export(download = false) {
    return super
      .post({}, { url: `${this.url}/export?download=${download}`, responseType: 'blob' })
      .then((response) => response)
      .catch((error) => error.response);
  }

  download() {
    return super
      .post({}, { url: `${this.url}/download`, responseType: 'blob' })
      .then((response) => response)
      .catch((error) => error.response);
  }

  updateStatus(status) {
    return super
      .put({}, { url: `${this.url}/status/${status}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  listOrganizations() {
    return super
      .get({ url: `${this.url}/organisations` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  purchaseEmail() {
    return new QuotePurchaseEmailResource(`${this.url}/purchase_email`);
  }

  purchaseSettings() {
    return new QuotePurchaseSettingsResource(`${this.url}/purchase_settings`);
  }

  attachments() {
    return new QuoteAttachmentResource(`${this.url}/attachments`);
  }

  conversations() {
    return new QuoteConversationResource(`${this.url}/conversations`);
  }

  item() {
    return new QuoteItemResource(`${this.url}/items`);
  }
}
